import { createSelector } from 'reselect'

export const getFees = (state, paymentschemeID) => state.paymentscheme.getIn(['items', paymentschemeID])

export const makeGetTotalFee = () => {
  let total = 0
  return createSelector(
    [getFees],
    (fees) => {
      if (fees) {
        fees.map((fee) => total += fee.get('amount') - 0)
      }
      return total
    }
  )
}



// WEBPACK FOOTER //
// ./src/containers/Manage/PaymentSchemes/selectors.js